module.exports = "/static/assets/b96acdcc724f0651325c9c54b8daeb23.gif";